import React, { useId, isValidElement, cloneElement } from "react";
import "./Field.css";
import { clsx } from "../../utils/clsx";

export default function Field({ label, htmlFor, required, hint, error, className, children }) {
  const genId = useId();
  const inputId = htmlFor || genId;
  const hintId = hint ? `${inputId}__hint` : undefined;
  const errorId = error ? `${inputId}__error` : undefined;

  // Compute describedby chain and inject into the single child control if applicable
  let control = children;
  try {
    const child = Array.isArray(children) ? children[0] : children;
    if (isValidElement(child)) {
      const existing = child.props["aria-describedby"] || "";
      const parts = [existing, errorId, hintId].filter(Boolean).join(" ").trim() || undefined;
      control = cloneElement(child, {
        id: child.props.id || inputId,
        "aria-invalid": error ? true : child.props["aria-invalid"],
        ...(parts ? { "aria-describedby": parts } : {}),
      });
    }
  } catch {}

  return (
    <div className={clsx("ds-field", error && "ds-field--invalid", className)}>
      {label && (
        <label htmlFor={inputId} className="ds-label">
          {label}
          {required ? <span aria-hidden>*</span> : null}
        </label>
      )}
      {control}
      {error ? (
        <div id={errorId} className="ds-error" role="alert">{error}</div>
      ) : hint ? (
        <div id={hintId} className="ds-hint">{hint}</div>
      ) : null}
    </div>
  );
}
